/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Week_Session_Day_Names_SaturdayInputs */

const fr_week_session_day_names_saturday = /** @type {(inputs: Week_Session_Day_Names_SaturdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sam`)
};

/**

* @param {Week_Session_Day_Names_SaturdayInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const week_session_day_names_saturday = /** @type {((inputs?: Week_Session_Day_Names_SaturdayInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Week_Session_Day_Names_SaturdayInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_week_session_day_names_saturday(inputs)
});